export default "__VITE_ASSET__WZsUwF8C__"